<template>
<!--  新闻中心-->
  <div class="productPage">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="itemData.imgBoxUrl" class="el-image__inner">
      </div>
    </div>
    <div class="contentBox">
      <div class="new_body" v-for="item in itemData.newDate">
        <div class="new_img">
          <img :src="item.imgUrl" class="new_img_1">
        </div>
        <div class="new_text">
          <div class="new_tatil">
            {{item.text1}}
          </div>
          <div class="new_date">
            {{item.text2}}
          </div>
          <div class="new_count">
            {{item.text3}}
          </div>
          <div class="new_ll" @click="goToItem(item.index)">
            <div class="new_all_p">{{item.text4}}</div>
            <i class="el-icon-caret-right tu"></i>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {Data} from "./js/news";

export default {
  name: "news",
  data() {
    return {
      dataAll: Data,
      itemData: {},

    }
  },
  mounted() {
    let that = this;

    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      if(that.$parent.message == itemData.type){
        that.itemData = itemData;
        break;
      }
    }

  },
  methods:{
    goToItem(index){
      this.$router.push('/newsItem?index='+index);
    }
  }
}
</script>

<style scoped>
.new_img_1{
  border-radius: 10px;
  width: 100%;
  height: 100%;
}

.new_ll{
  display: flex;
  margin-top: 38px;
}
.new_text{
  margin-top: 30px;
  margin-right: 15px;
  width: 69.29%;
}
.new_img{
  display: flex;
  align-items: center;
  width: 30.61%;
  aspect-ratio: 360/284;
  margin: 20px;
}
.new_all_p{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #63B62E;
  text-align: justify;

}
.tu{
  color: #63B62E;
}
.new_count{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #666666;
  letter-spacing: 0;
  text-align: justify;
  line-height: 28px;
}
.new_date{
  font-family: SourceHanSansCN;
  font-size: 14px;
  color: #999999;
  text-align: justify;
  margin-bottom: 15px;
}
.new_tatil{
  font-family: SourceHanSansCN;
  font-size: 24px;
  color: #333333;
  text-align: justify;
  margin-bottom: 15px;
}
.new_body{
  width: 100%;
  aspect-ratio: 1176/324;
  margin-top: 20px;
  display: flex;
  background-color: #FFFFFF;

}
.contentBox {
  width: 61.25%;
  margin: 50px auto;
}
.productPage {
  display: block;
  width: 100%;
  background-color: #FFFFFF;
}
.imgBox {
  width: 100%;
  aspect-ratio: 1920/600;
}

.imageItem {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/news.vue